<template>
  <tr class="row row-parent is-expanded">
    <td
      :colspan="colspan"
      class="cell-child-table"
    >
      <slot
        name="childTable"
        :data="childData"
        :columns="childColumns"
      />
    </td>
  </tr>
</template>

<script>
  export default {
    name: 'TfTableChildTable',
    props: {
      childData: {
        type: Object,
        default: () => ({}),
      },
      childColumns: {
        type: Array,
        default: () => [],
      },
      colspan: {
        type: Number,
        default: 1,
      },
    },
  };
</script>
